import React from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App render error:", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
          <div className="max-w-md w-full text-center bg-card border rounded-xl shadow-soft p-8 animate-fade-in-up">
            <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-emerald-50 flex items-center justify-center">
              <AlertTriangle className="h-6 w-6 text-brand" />
            </div>
            <h2 className="text-lg font-bold" style={{ fontFamily: "Outfit" }}>Terjadi Kesalahan</h2>
            <p className="text-sm text-muted-foreground mt-2">
              Maaf, halaman mengalami gangguan. Silakan muat ulang halaman atau kembali ke beranda.
            </p>
            <div className="flex gap-2 justify-center mt-5">
              <button onClick={this.handleReload} data-testid="error-reload-btn"
                className="bg-brand text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-emerald-800 transition-colors">
                Muat Ulang
              </button>
              <a href="/" className="border px-4 py-2 rounded-lg text-sm font-medium hover:bg-secondary transition-colors">
                Beranda
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
